import { render, staticRenderFns } from "./MoneyTransferForm.vue?vue&type=template&id=bbc920cc"
import script from "./MoneyTransferForm.vue?vue&type=script&lang=ts"
export * from "./MoneyTransferForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports